/**
 * Generates a unique ID.
 *
 * @returns String
 */
const existingUniqueIds = {};
export function uniqueId() {
    const range = Math.pow(10, 9);
    let id = null;
    while (!id || existingUniqueIds[id]) {
        id = 'id' + ((Math.random() * range)|0).toString(36);
    }
    existingUniqueIds[id] = true;
    return id;
}



// WEBPACK FOOTER //
// ./source/scripts/utils/data.js